import AntRow from 'antd/lib/row';

export const Row = AntRow;
